import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatError, MatFormField} from '@angular/material/form-field';
import {AbstractControlOptions, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {MatProgressBar} from '@angular/material/progress-bar';

@Component({
  standalone: true,
  selector: 'app-dialog-change-name',
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatFormField,
    FormsModule,
    MatInput,
    MatError,
    MatProgressBar,
    ReactiveFormsModule
  ],
  templateUrl: './dialog-single-field-edit.component.html',
  styleUrls: ['../../../settings-fields.scss']
})
export class DialogSingleFieldEditComponent {
  title = 'Title';
  fieldName = 'Name';
  actionLabel = 'Proceed';

  formGroup: FormGroup;

  performingAction = false;
  actionError: any;

  constructor(readonly dialog: MatDialogRef<any>,
              private readonly fb: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: SingleFieldEditData) {
    this.title = data.title || 'Enter Value';
    this.actionLabel = data.actionLabel || 'OK';
    this.fieldName = data.fieldName || 'Name';
    this.createFromGroup(data.value, data.asyncValidator);
  }

  private createFromGroup(value: string, asyncValidator?: (value: string) => Promise<string | null>) {
    const valueOptions: AbstractControlOptions = {};

    if (asyncValidator) {
      const boundValidator = asyncValidator.bind(this);

      valueOptions.asyncValidators = async (control) => {
        const { value: controlValue } = control;
        const validationMessage = await boundValidator(controlValue);
        return validationMessage ? {invalid: validationMessage} : null;
      };
    }
    this.formGroup = this.fb.group({
      value: this.fb.control(value, valueOptions)
    });
  }

  performAction() {
    const {value} = this.formGroup.value;
    this.performingAction = true;
    this.data.action.call(this, value).then((result) => {
      this.dialog.close(result);
    }).catch((error) => {
      this.actionError = error;
    }).finally(() => {
      this.performingAction = false;
    });
  }
}

export interface SingleFieldEditData {
  title: string;
  value: string;
  actionLabel: string;
  fieldName?: string;
  /**
   * validate the value and return error message for invalid or `null` for valid.
   */
  asyncValidator?: (value: string) => Promise<string | null>;
  action: (value: string) => Promise<any>;
}
